import { AUTH_LOGOUT } from '../../../../../common/redux/actions/types/authActionTypes';
import {
  ADD_MRD_REQUEST, ADD_MRD_STATUS, ADD_MRD_SUCCESS,
  EDIT_MRD_REQUEST, EDIT_MRD_SUCCESS,
  GET_MRD_STATUSES_SUCCESS,
  GET_MRD_TYPES_SUCCESS,
  GET_POSTAL_OPERATORS_SUCCESS,
  ASSOCIATE_HANDLER_STATUS, GET_ACTIVE_MRD_LIST_SUCCESS,
  FETCH_INBOUND_DATA_LOCATION_LIST_SUCCESS,
} from '../actions/types/DeviceInformationActionTypes';

export const initialState = {
  statuses: [],
  types: [],
  operators: [],
  inboundDataLocationList: [],
  editMrdSuccess: false,
  addMrdSuccess: false,
  persistFormData: {},
  associateHandlerSuccess: false,
};

const DeviceInformationReducer = (state = initialState, action) => {
  switch (action.type) {
  case GET_MRD_STATUSES_SUCCESS:
    return {
      ...state,
      statuses: action.payload,
    };
  case GET_MRD_TYPES_SUCCESS:
    return {
      ...state,
      types: action.payload,
    };
  case GET_POSTAL_OPERATORS_SUCCESS:
    return {
      ...state,
      operators: action.payload,
    };
  case FETCH_INBOUND_DATA_LOCATION_LIST_SUCCESS:
    return {
      ...state,
      inboundDataLocationList: action.payload,
    };
  case EDIT_MRD_REQUEST:
    return {
      ...state,
      editMrdSuccess: false,
    };
  case EDIT_MRD_SUCCESS:
    return {
      ...state,
      editMrdSuccess: true,
    };
  case ADD_MRD_REQUEST:
    return {
      ...state,
      persistFormData: action.persistFormData,
    };
  case ADD_MRD_SUCCESS:
    return {
      ...state,
      persistFormData: {},
    };
  case ADD_MRD_STATUS:
    return {
      ...state,
      addMrdSuccess: action.status,
    };
  case ASSOCIATE_HANDLER_STATUS:
    return {
      ...state,
      associateHandlerSuccess: action.status,
    };
  case GET_ACTIVE_MRD_LIST_SUCCESS:
    return {
      ...state,
      activeMrdList: action.payload,
    };
  case AUTH_LOGOUT:
    return initialState;
  default:
    return state;
  }
};

export default DeviceInformationReducer;
